import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { pickBy, isEmpty, map } from 'lodash';
/**
 * WordPress dependencies
 */

import { useMemo } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { SelectControl, Placeholder } from '@wordpress/components';
import { BlockIcon } from '@wordpress/block-editor';
export default function LegacyWidgetPlaceholder(_ref) {
  var availableLegacyWidgets = _ref.availableLegacyWidgets,
      currentWidget = _ref.currentWidget,
      hasPermissionsToManageWidgets = _ref.hasPermissionsToManageWidgets,
      onChangeWidget = _ref.onChangeWidget;
  var visibleLegacyWidgets = useMemo(function () {
    return pickBy(availableLegacyWidgets, function (_ref2) {
      var isHidden = _ref2.isHidden;
      return !isHidden;
    });
  }, [availableLegacyWidgets]);
  var placeholderContent;

  if (!hasPermissionsToManageWidgets) {
    placeholderContent = __('You don\'t have permissions to use widgets on this site.');
  }

  if (isEmpty(visibleLegacyWidgets)) {
    placeholderContent = __('There are no widgets available.');
  }

  placeholderContent = createElement(SelectControl, {
    label: __('Select a legacy widget to display:'),
    value: currentWidget || 'none',
    onChange: onChangeWidget,
    options: [{
      value: 'none',
      label: 'Select widget'
    }].concat(map(visibleLegacyWidgets, function (widget, key) {
      return {
        value: key,
        label: widget.name
      };
    }))
  });
  return createElement(Placeholder, {
    icon: createElement(BlockIcon, {
      icon: "admin-customizer"
    }),
    label: __('Legacy Widget')
  }, placeholderContent);
}
//# sourceMappingURL=placeholder.js.map